import { z } from 'zod';

export const recipientOfPaymentSchema = z.object({
    id: z.number().default(-1),
    recipient: z.string().default(""),
    iban: z.string().default(""),
    bic: z.string().default(""),
})
export type IRecipientOfPayment = z.infer<typeof recipientOfPaymentSchema>;